export default __webpack_public_path__ + "static/UniversitaCattolica-ae59a8aa89787dff73806318d1f7ee6c.svg";